import { CALL } from "./action-types";

export const videoCall = (payload) => ({
  type: CALL,
  payload,
});
